import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth-guard.service';
import { AppComponent } from './app.component';
import { PublicComponent } from './public/public.component';
import { LoginComponent } from './public/login/login.component';
import { LogoutComponent } from './public/logout/logout.component';
import { RegisterComponent } from './public/register/register.component';
import { NewpasswordComponent } from './public/newpassword/newpassword.component';
import { ConfirmComponent } from './public/confirm/confirm.component';
import { ForgotComponent, Forgot2Component } from './public/forgot/forgot.component';
import { ForgotEmailComponent } from './public/forgot-email/forgot-email.component';
import { ResendComponent } from 'app/public/resend/resend.component';
import { SmartHomeComponent } from './smarthome/smarthome.component';
import { CancelComponent } from './ntv/cancel/cancel.component';
import { NtvErrorComponent } from './ntv/ntverror/ntverror.component';
import { ApplicationComponent } from './application/application.component';

import { ContactInfoCogComponent } from './renewal-cog/contact-info-cog/contact-info-cog.component';
import { RenewalErrorCogComponent } from './renewal-cog/renewal-error-cog/renewal-error-cog.component';
import { OtherOccupantCogComponent } from './renewal-cog/other-occupant-cog/other-occupant-cog.component';
import { RoommateInfoCogComponent } from './renewal-cog/roommate-info-cog/roommate-info-cog.component';
import { ChoosePlanCogComponent } from './renewal-cog/choose-plan-cog/choose-plan-cog.component';
import { RenewalDashboardCogComponent } from './renewal-cog/renewal-dashboard-cog/renewal-dashboard-cog.component';


import { AccountManagementComponent } from './account/account-management/account-management.component';
import { NonLegacyLeasesDashboardComponent } from './leases/non-legacy-leases-dashboard/non-legacy-leases-dashboard.component';
import { NonLegacyLeasesErrorComponent } from './leases/non-legacy-leases-error/non-legacy-leases-error.component'

import { DocumentSignComponent } from './document-sign-base/document-sign/document-sign.component';
import { ProspectComponent } from './prospect/prospect.component'
import { TourAgreeComponent } from './prospect/tour-agree/tour-agree.component'
import { OpenhouseSelectComponent } from './prospect/openhouse-select/openhouse-select.component'
import { TourSummaryComponent } from './prospect/tour-summary/tour-summary.component'
import { ShowingDateselectComponent } from './prospect/showing-dateselect/showing-dateselect.component';
import { ShowingTimeselectComponent } from './prospect/showing-timeselect/showing-timeselect.component';
import { TourDashboardComponent } from './prospect/tour-dashboard/tour-dashboard.component';
import { SelftourBaseComponent } from './prospect/selftour-base/selftour-base.component';
import { UploadDlComponent } from './prospect/selftour-base/upload-dl/upload-dl.component';
import { ConfirmInfoComponent } from './prospect/selftour-base/confirm-info/confirm-info.component';
import { ScheduleSelftourComponent } from './prospect/selftour-base/schedule-selftour/schedule-selftour.component';
import { SubmitPaymentComponent } from './prospect/selftour-base/submit-payment/submit-payment.component';
import { SummarySelftourComponent } from './prospect/selftour-base/summary-selftour/summary-selftour.component';
import { SelftourVerifyBaseComponent } from './prospect/selftour-verify-base/selftour-verify-base.component';
import { VerifyLocationComponent } from './prospect/selftour-verify-base/verify-location/verify-location.component';
import { VerifyIdentityComponent } from './prospect/selftour-verify-base/verify-identity/verify-identity.component';
import { LocateAgreeComponent } from './prospect/selftour-verify-base/locate-agree/locate-agree.component';
import { VerifyConfirmedComponent } from './prospect/selftour-verify-base/verify-confirmed/verify-confirmed.component';
import { TourProspectVerifyComponent } from './prospect/tour-prospect-verify/tour-prospect-verify.component';
import { PrimaryRenewalEmploymentComponent } from './renewal-cog/primary-renewal-employment-cog/primary-renewal-employment-cog.component';
import { RoommateConfirmEmployerComponent } from './renewal-cog/roommate-confirm-employer-cog/roommate-confirm-employer-cog.component';
import { FavDashboardComponent } from './favorites/fav-dashboard/fav-dashboard.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { DocumentSignBaseComponent } from './document-sign-base/document-sign-base.component';
import { AdditionalPropertyComponent } from './application/additional-property-base/additional-property/additional-property.component';
import { AdditionalPropertyBaseComponent } from './application/additional-property-base/additional-property-base.component';
import { SmartHomeDashboardComponent } from './smarthome/smart-home-dashboard/smart-home-dashboard.component';

import { WorkOrderComponent } from './work-order/work-order.component';
import { WorkOrderCreateComponent } from './work-order/work-order-create/work-order-create.component';
import { WorkOrderDashboardComponent } from './work-order/work-order-dashboard/work-order-dashboard.component';
import { RenewalCogComponent } from './renewal-cog/renewal-cog.component';
import { RenewalReviewCogComponent } from './renewal-cog/renewal-review-cog/renewal-review-cog.component';
import { VerifastVerifyComponent } from './prospect/selftour-base/verifast-verify/verifast-verify.component';
import { BrokerHomeComponent } from './broker/broker-home/broker-home.component';
import { BrokerComponent } from './broker/broker.component';
import { ErrorComponent } from './prospect/selftour-verify-base/error/error.component';
const appRoutes: Routes = [
  { path: 'home', component: AppComponent },

  //redirect to public component
  { path: 'login', redirectTo: '/public/login' },
  { path: 'logout', redirectTo: '/public/logout' },
  { path: 'newpassword', redirectTo: '/public/newpassword' },
  { path: 'register', redirectTo: '/public/register' },
  { path: 'confirm', redirectTo: '/public/confirm' },
  { path: 'confirm/:username', redirectTo: '/public/confirm/:username' },
  { path: 'forgot/:email', redirectTo: '/public/forgot/:email' },
  { path: 'forgot', redirectTo: '/public/forgot' },
  { path: 'forgotEmail', redirectTo: '/public/forgotEmail' },
  { path: 'resend', redirectTo: '/public/resend' },
  { path: 'public/document-sign', redirectTo: 'document-sign/sign' },

  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: 'login', component: LoginComponent, children: [
              { path: 'newpassword', component: NewpasswordComponent },
            ]
          },
          { path: 'login/:username', component: LoginComponent },
          { path: 'login/redirect/:preserveRedirect', component: LoginComponent },
          { path: 'login/renewal/:renew', component: LoginComponent },
          { path: 'login/account/:manage', component: LoginComponent },
          { path: 'login/tours/:dash', component: LoginComponent },
          { path: 'login/callback/:callbackURL', component: LoginComponent },
          { path: 'login/tour/:tourType/:yardiID', component: LoginComponent },
          { path: 'logout', component: LogoutComponent },
          {
            path: 'register', component: RegisterComponent, children: [
              { path: 'confirm', component: ConfirmComponent },
              { path: 'confirm/:username', component: ConfirmComponent },
            ]
          },
          { path: 'register/callback/:callbackURL', component: RegisterComponent },
          { path: 'forgot/:email', component:  Forgot2Component},
          { path: 'forgot', component: ForgotComponent },
          { path: 'resend', component: ResendComponent },
          { path: 'forgotEmail', component: ForgotEmailComponent },
        ]
      }
    ]
  },
  {
    path: 'document-sign',
    component: DocumentSignBaseComponent,
    children: [
      {
        path: '',
        children: [
          { path: 'sign', component: DocumentSignComponent },
        ]
      }
    ]
  },
  {
    path: 'tour',
    component: ProspectComponent,
    children: [
      {
        path: '',
        children: [
          { path: 'verify', component: TourProspectVerifyComponent, canActivate: [AuthGuard] },
          { path: 'agree', component: TourAgreeComponent, canActivate: [AuthGuard] },
          { path: 'openhouseselect', component: OpenhouseSelectComponent, canActivate: [AuthGuard] },
          { path: 'toursummary/:recordKey', component: TourSummaryComponent, canActivate: [AuthGuard] },
          { path: 'showingdateselect', component: ShowingDateselectComponent, canActivate: [AuthGuard] },
          { path: 'showingtimeselect', component: ShowingTimeselectComponent, canActivate: [AuthGuard] },
          {
            path: 'selftour', component: SelftourBaseComponent, canActivate: [AuthGuard], children: [
              { path: 'upload-dl', component: UploadDlComponent, canActivate: [AuthGuard] },
              { path: 'verifast-verify', component: VerifastVerifyComponent, canActivate: [AuthGuard] },
              { path: 'confirm-info', component: ConfirmInfoComponent, canActivate: [AuthGuard] },
              { path: 'submit-payment', component: SubmitPaymentComponent, canActivate: [AuthGuard] },
              { path: 'schedule-selftour', component: ScheduleSelftourComponent, canActivate: [AuthGuard] },
              { path: 'summary-selftour', component: SummarySelftourComponent, canActivate: [AuthGuard] },
            ]
          },
          {
            path: 'selftour-start', component: SelftourVerifyBaseComponent, canActivate: [AuthGuard], children: [
              { path: 'locate-agree', component: LocateAgreeComponent, canActivate: [AuthGuard] },
              { path: 'verify-location', component: VerifyLocationComponent, canActivate: [AuthGuard] },
              { path: 'verify-identity', component: VerifyIdentityComponent, canActivate: [AuthGuard] },
              { path: 'verify-confirmed', component: VerifyConfirmedComponent, canActivate: [AuthGuard] },
              { path: 'error', component: ErrorComponent, canActivate: [AuthGuard] }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'smarthome',
    component: SmartHomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'devices', component: SmartHomeDashboardComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  {
    path: 'maintenance',
    component: WorkOrderComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'dashboard', component: WorkOrderDashboardComponent, canActivate: [AuthGuard] },
          { path: 'create', component: WorkOrderCreateComponent, canActivate: [AuthGuard], canDeactivate: ['WorkOrderCreateGuardService'] }
        ]
      }
    ]
  },
  {
    path: 'ntv',
    component: PublicComponent,
    children: [
      {
        path: '',
        children: [
          { path: 'ntverror', component: NtvErrorComponent },
          { path: 'cancel', component: CancelComponent }
        ]
      }
    ]
  },
  {
    path: 'renewalcog',
    component: RenewalCogComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'renewal-error', component: RenewalErrorCogComponent, canActivate: [AuthGuard] },
          { path: 'renewal-dashboard', component: RenewalDashboardCogComponent, canActivate: [AuthGuard] },
          {
            path: 'renewal-review', component: RenewalReviewCogComponent, canActivate: [AuthGuard], children: [
              { path: 'contact-info', component: ContactInfoCogComponent, canActivate: [AuthGuard] },
              { path: 'other-occupant', component: OtherOccupantCogComponent, canActivate: [AuthGuard] },
              { path: 'roommate-info', component: RoommateInfoCogComponent, canActivate: [AuthGuard] },
              { path: 'employment-info', component: PrimaryRenewalEmploymentComponent, canActivate: [AuthGuard] },
              { path: 'choose-plan', component: ChoosePlanCogComponent, canActivate: [AuthGuard] },
              { path: 'confirm-employer', component: RoommateConfirmEmployerComponent, canActivate: [AuthGuard] }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'leases',
    component: ApplicationComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'non-legacy-leases-error', component: NonLegacyLeasesErrorComponent, canActivate: [AuthGuard] },
          { path: 'non-legacy-leases-dashboard', component: NonLegacyLeasesDashboardComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  {
    path: 'account',
    component: ApplicationComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'account-management', component: AccountManagementComponent, canActivate: [AuthGuard] },
          { path: 'tours', component: TourDashboardComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  {
    path: 'favorites',
    component: FavoritesComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'dashboard', component: FavDashboardComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  {
    path: 'additional-prop',
    component: AdditionalPropertyBaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'additional', component: AdditionalPropertyComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  {
    path: 'broker',
    component: BrokerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'home', component: BrokerHomeComponent, canActivate: [AuthGuard] }
        ]
      }
    ]
  },
  { path: '', redirectTo: '/application/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/application/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }